module.exports = __webpack_public_path__ + "static/img/200168.ff912b3c.png";